import { roleEnum } from "../utils/enums";

export const authMixin = {
  data() {
    return {
      roles: roleEnum
    };
  },
  methods: {
    login(userData) {
      localStorage.setItem("token", userData.token);
      localStorage.setItem("roleId", userData.roleId);
      this.$http.defaults.headers.common["token"] = userData.token;
      this.$i18n.locale = "de";
      this.$router.push("requests");
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("roleId");
      this.$router.push("login");
    },
    isUserRole(role) {
      return localStorage.getItem("roleId") === role;
    }
  }
};
